define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function NameTooLongFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    NameTooLongFail.WEB_BACKEND_ERROR = 'name_too_long';

    NameTooLongFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: NameTooLongFail,
        className: 'NameTooLongFail',
        radarName: 'fail_{SOURCE}_name-too-long',
        message: [
            'Превышена длина имени.',
            '<a href="https://help.mail.ru/cloud_web/confines" rel="noopener" target="_blank">Подробнее</a>',
        ].join(' '),
    });

    module.exports = NameTooLongFail;
});
